module.exports = "<div class=\"login\">\n    <md-button @click.native=\"googleSignIn()\" class=\"md-raised md-warn\">\n      Sign in with Google\n    </md-button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/login.html
// module id = 105
// module chunks = 1